import { getCookie } from "@/lib/getCookie";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  // Check for token
  const token = getCookie("accessToken");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
